import React from "react";
import { Link } from "react-router-dom";
import DashboardHeader from "../../Header/DashboardHeader";
import DashboardFooter from "../../Footer/DashboardFooter";
import DashboardLeftMenu from "../DashboardLeftMenu";
import whatsapp from "../../Dashboard/assets/img/whstaApp-conversations.png";
import Postman from "../../Dashboard/assets/img/Postman.png";
import sms from "../../Dashboard/assets/img/sms-icon.png";
import voice from "../../Dashboard/assets/img/voice-icon.png";
import email from "../../Dashboard/assets/img/email-icon.png";
import RcsBlackImage from "../../Dashboard/assets/img/rcs.svg-removebg-preview.png";
const DashboardAPi = () => {
  const domain = window.location.protocol + "//" + window.location.host;
   const domain1 = window.location.hostname;
  const allowedDomains = ["console.authkey.io", "localhost:3000"];
  const currentDomain = window.location.host;
  const showHelpButton = allowedDomains.includes(currentDomain);

  return (
    <div className="wrapper">
      <DashboardLeftMenu />
      <div className="main">
        <DashboardHeader />
        <main className="content">
          <div className="container-fluid p-0">
            <div className=" row mb-2 mb-xl-3">
              <div className="col-auto d-none d-sm-block">
                <h3>
                  <strong>API Docs</strong>
                </h3>
              </div>
            </div>
            <div className="">
              <div className="card">
                <div className="card-body">
                  <div className="text-center">
                    <h5 className="">
                      Welcome to {domain1}! Get familiar with our product and
                      explore its features:
                    </h5>

                    <p className="lead text-muted lh-190">
                      {domain1} APIs are fast, AI-Driven and supports message
                      deliveries through multiple channels in the same request.
                      You can choose multiple channel deliveries in parallel or
                      fallback as per your requirement. You also have options to
                      create templates with dynamic contents and also club
                      multiple templates into events to be triggered via a
                      single API request.
                    </p>

                    <h6 className="my-4 text-bold">
                      Channels supported by {domain1}:
                    </h6>

                    {/* <div className="row mb-5">
                      <div className="col-sm-3">
                        <div className="card rounded-lg mb-sm-0 channelsms cardApiH">
                          <div className="p-3 text-center">
                            <img
                              src={sms}
                              alt="api"
                              className="img-fluid apicons"
                            />
                            <h5 className="mb-2 mt-2">SMS</h5>
                            <p className="text-sm mt-2 mb-0">
                              Transactional SMS can be triggered either by
                              directly passing the sms message in the API
                              request or you can also create a template with
                              dynamic values and use the template identifier in
                              the API request.
                            </p>
                            <Link
                              className="btn btn-sm btn-primary mt-3"
                              to="/dashboard/sms-api-docs"
                            >
                              Read More
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3">
                        <div className="card rounded-lg mb-sm-0 cardApiH">
                          <div className="p-3 text-center">
                            <img
                              src={voice}
                              alt="api voice"
                              className="img-fluid apicons"
                            />
                            <h5 className="mb-2 mt-2"> Voice </h5>
                            <p className=" mt-2 mb-0 text-sm">
                              Voice call can be placed from Authkey by passing
                              the voice message in text in the API request. The
                              platform will auto-convert the text into audio and
                              place the call. Use it in the API to create voice
                              template.
                            </p>
                            <Link
                              className="btn btn-sm btn-primary mt-3"
                              to="/dashboard/voice-api-docs"
                            >
                              Read More
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3">
                        <div className="card rounded-lg mb-sm-0 cardApiH">
                          <div className="p-2 py-3 text-center">
                            <img
                              src={email}
                              alt="email"
                              className="img-fluid apicons"
                            />
                            <h5 className="mb-2 mt-2">Email</h5>
                            <p className=" mt-2 mb-0 text-sm">
                              Create Email templates on Authkey and use the
                              created template id in the API request to send
                              email. Authkey uses AWS SES to send emails, so you
                              need to have an account in AWS to use this
                              feature.
                            </p>
                            <Link
                              className="btn btn-sm btn-primary mt-3"
                              to="/dashboard/email-api-docs"
                            >
                              Read More
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3">
                        <div className="card rounded-lg mb-sm-0 cardApiH">
                          <div className="p-2 py-3 text-center">
                            <img
                              src={whatsapp}
                              alt="whatsapp"
                              className="img-fluid apicons"
                            />
                            <h5 className="mt-2 mb-2">WhatsApp</h5>
                            <p className=" mt-2 mb-0 text-sm">
                              Whatsapp API is a communication connection to
                              enable a marketing lineup to customers or
                              prospects. Whatsapp business web was launched in
                              Aug '18 for marketers to scale their engagements.
                            </p>
                            <Link
                              className="btn btn-sm btn-primary mt-3"
                              to="/dashboard/whatsapp-api-docs"
                            >
                              Read More
                            </Link>
                          </div>
                        </div>
                      </div>
                        <div className="col-sm-3">
                        <div className="card rounded-lg mb-sm-0 cardApiH">
                          <div className="p-2 py-3 text-center">
                            <img
                              src={RcsBlackImage}
                              alt="whatsapp"
                              className="img-fluid apicons"
                            />
                            <h5 className="mt-2 mb-2">RCS</h5>
                            <p className=" mt-2 mb-0 text-sm">
                              Transactional RCS can be triggered either by
                              directly passing the RCS message in the API
                              request or you can also create a template with
                              dynamic values and use the template identifier in
                              the API request.
                            </p>
                            <Link
                              className="btn btn-sm btn-primary mt-3"
                              to="/dashboard/whatsapp-api-docs"
                            >
                              Read More
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div> */}

                    <div className="container my-5">

                      {/* First row */}
                      <div className="row g-5 mb-5">
                       
                        {/* SMS Card */}
                        <div className="col-md-4">
                          <div className="card shadow-sm border border-3 text-center p-3 h-100" style={{ borderColor: "#ec4899" }}>
                            <div className="rounded-circle mx-auto d-flex align-items-center justify-content-center mb-3" style={{ width: "50px", height: "50px", backgroundColor: "#fde7f3" }}>
                              <img src={sms} alt="SMS Icon" className="w-50" />
                            </div>
                            <h6 className="fw-bold mb-2 fs-6">SMS</h6>
                            <p className="text-muted small mb-3">
                              Transactional SMS can be triggered either by directly passing the SMS message in the API request or you can also create a template with dynamic values and use the template identifier in the API request.
                            </p>
                            <Link to="/dashboard/sms-api-docs" className="btn btn-sm btn-outline-primary">
                              Read More
                            </Link>
                          </div>
                        </div>

                        {/* Voice Card */}
                        <div className="col-md-4">
                          <div className="card shadow-sm border border-3 text-center p-3 h-100" style={{ borderColor: "#22c55e" }}>
                            <div className="rounded-circle mx-auto d-flex align-items-center justify-content-center mb-3" style={{ width: "50px", height: "50px", backgroundColor: "#dcfce7" }}>
                              <img src={voice} alt="Voice Icon" className="w-50" />
                            </div>
                            <h6 className="fw-bold mb-2 fs-6">Voice</h6>
                            <p className="text-muted small mb-3">
                              Voice call can be placed from {domain1} by passing the voice message in text in the API request. The platform will auto-convert the text into audio and place the call. Use it in the API to create voice template.
                            </p>
                            <Link to="/dashboard/voice-api-docs" className="btn btn-sm btn-outline-primary">
                              Read More
                            </Link>
                          </div>
                        </div>

 {/* Email Card */}
                        <div className="col-md-4">
                          <div className="card shadow-sm border border-3 text-center p-3 h-100" style={{ borderColor: "#6366f1" }}>
                            <div className="rounded-circle mx-auto d-flex align-items-center justify-content-center mb-3" style={{ width: "50px", height: "50px", backgroundColor: "#e0e7ff" }}>
                              <img src={email} alt="Email Icon" className="w-50" />
                            </div>
                            <h6 className="fw-bold mb-2 fs-6">Email</h6>
                            <p className="text-muted small mb-3">
                              Create Email templates on {domain1} and use the created template id in the API request to send email.{domain1} uses AWS SES to send emails, so you need to have an account in AWS to use this feature.
                            </p>
                            <Link to="/dashboard/email-api-docs" className="btn btn-sm btn-outline-primary">
                              Read More
                            </Link>
                          </div>
                        </div>
                      </div>

                      {/* Second row */}
                      <div className="row g-5">
                        {/* POSTMAN Card */}
                        {showHelpButton && (
                        <div className="col-md-4">
                          <div className="card shadow-sm border border-3 text-center p-3 h-100" style={{ borderColor: "#ec4899" }}>
                            <div className="rounded-circle mx-auto d-flex align-items-center justify-content-center mb-3" style={{ width: "50px", height: "50px", backgroundColor: "#fde7f3" }}>
                              <img src={Postman} alt="SMS Icon" className="w-100" />
                            </div>
                            <h6 className="fw-bold mb-2 fs-6">POSTMAN</h6>
                            <p className="text-muted small mb-3">
                              {domain1} is a secure omnichannel platform offering a comprehensive suite of services, including SMS OTPs, transactional messages, promotional bulk SMS, WhatsApp Business messaging, Voice IVR, Email, and RCS messaging.
                            </p>
                            <a href="https://documenter.getpostman.com/view/28006064/2sAYXCje4N#intro" target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary">
                              Read More
                            </a>
                          </div>
                        </div>
                        )}
                        {/* WhatsApp Card */}
                        <div className="col-md-4">
                          <div className="card shadow-sm border border-3 text-center p-3 h-100" style={{ borderColor: "#facc15" }}>
                            <div className="rounded-circle mx-auto d-flex align-items-center justify-content-center mb-3" style={{ width: "50px", height: "50px", backgroundColor: "#fef9c3" }}>
                              <img src={whatsapp} alt="WhatsApp Icon" className="w-50" />
                            </div>
                            <h6 className="fw-bold mb-2 fs-6">WhatsApp</h6>
                            <p className="text-muted small mb-3">
                              Whatsapp API is a communication connection to enable a marketing lineup to customers or prospects. Whatsapp business web was launched in Aug '18 for marketers to scale their engagements.
                            </p>
                            <Link to="/dashboard/whatsapp-api-docs" className="btn btn-sm btn-outline-primary">
                              Read More
                            </Link>
                          </div>
                        </div>

                        {/* RCS Card */}
                        <div className="col-md-4">
                          <div className="card shadow-sm border border-3 text-center p-3 h-100" style={{ borderColor: "#a855f7" }}>
                            <div className="rounded-circle mx-auto d-flex align-items-center justify-content-center mb-3" style={{ width: "50px", height: "50px", backgroundColor: "#f3e8ff" }}>
                              <img src={RcsBlackImage} alt="RCS Icon" className="w-50" />
                            </div>
                            <h6 className="fw-bold mb-2 fs-6">RCS</h6>
                            <p className="text-muted small mb-3">
                              Transactional RCS can be triggered either by directly passing the RCS message in the API request or you can also create a template with dynamic values and use the template identifier in the API request.
                            </p>
                            <Link to="/dashboard/rcs-api-docs" className="btn btn-sm btn-outline-primary">
                              Read More
                            </Link>
                          </div>
                        </div>
                      </div>

                    </div>



                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <DashboardFooter />
      </div>
    </div>
  );
};

export default DashboardAPi;
